import { createUseStyles } from 'react-jss'

const useDatePickerStyles = createUseStyles({
  dayTimePicker: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start'
  },
  daySelect: {
    padding: '4px',
    width: '130px'
  },
  timeSelect: {
    border: '1px solid #ddd',
    background: '#fff',
    borderRadius: 4,
    width: 100,
    height: 40,
    textAlign: 'center',
    '&:focus': {
      outline: 0,
      border: '1px solid #ddd'
    },
    '&:disabled': {
      opacity: 0.5
    }
  }
})

export { useDatePickerStyles }
